module.exports = __webpack_public_path__ + "static/media/walking_woman.c598ad92.svg";